import { render, staticRenderFns } from "./Maritime.vue?vue&type=template&id=72dafe33&scoped=true"
import script from "./Maritime.vue?vue&type=script&lang=js"
export * from "./Maritime.vue?vue&type=script&lang=js"
import style0 from "./Maritime.vue?vue&type=style&index=0&id=72dafe33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dafe33",
  null
  
)

export default component.exports